import { Box, Stack, Typography } from "@mui/material";

import LearnVisualFrame from "./LearnVisualFrame";

function OwnershipBar({ owned, total }) {
  const ownedPct = Math.max(0, Math.min((owned / total) * 100, 100));
  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: `${ownedPct}% 1fr`,
        height: 20,
        borderRadius: 1,
        overflow: "hidden",
        border: "1px solid rgba(34, 35, 37, 0.12)",
        backgroundColor: "rgba(34, 35, 37, 0.05)",
      }}
    >
      <Box sx={{ backgroundColor: "rgba(201, 176, 123, 0.86)" }} />
      <Box sx={{ backgroundColor: "rgba(34, 35, 37, 0.06)" }} />
    </Box>
  );
}

function OwnershipPanel({ label, totalShares, ownedShares }) {
  const percent = ((ownedShares / totalShares) * 100).toFixed(1);
  return (
    <Box
      sx={{
        flex: 1,
        minWidth: 240,
        p: 2,
        border: "1px solid rgba(34, 35, 37, 0.12)",
        borderRadius: 1,
        backgroundColor: "rgba(255, 255, 255, 0.70)",
      }}
    >
      <Typography sx={{ fontSize: 12, fontWeight: 900, color: "text.secondary", textTransform: "uppercase", letterSpacing: 0 }}>
        {label}
      </Typography>
      <Typography sx={{ mt: 1, fontSize: 15, fontWeight: 850 }}>
        {totalShares} shares outstanding
      </Typography>
      <Typography sx={{ mt: 0.35, mb: 1.25, fontSize: 13.5, color: "text.secondary" }}>
        You own <Box component="strong" sx={{ color: "text.primary", fontWeight: 900 }}>{ownedShares} shares</Box>
      </Typography>
      <OwnershipBar owned={ownedShares} total={totalShares} />
      <Typography sx={{ mt: 1, fontSize: 20, fontWeight: 900 }}>
        {percent}% ownership
      </Typography>
    </Box>
  );
}

export default function ShareDilutionVisual({ title, takeaway, caption, data = {} }) {
  const beforeShares = data.beforeShares ?? 100;
  const newShares = data.newShares ?? 25;
  const ownedShares = data.ownedShares ?? 10;
  const afterShares = beforeShares + newShares;

  return (
    <LearnVisualFrame title={title} takeaway={takeaway} caption={caption} size="compact">
      <Stack direction={{ xs: "column", md: "row" }} spacing={2} alignItems="stretch">
        <OwnershipPanel label="Before Financing" totalShares={beforeShares} ownedShares={ownedShares} />
        <Box
          sx={{
            alignSelf: "center",
            px: { xs: 0, md: 1 },
            fontSize: 30,
            fontWeight: 900,
            color: "primary.main",
          }}
          aria-hidden="true"
        >
          →
        </Box>
        <OwnershipPanel label={`${newShares} New Shares Issued`} totalShares={afterShares} ownedShares={ownedShares} />
      </Stack>
    </LearnVisualFrame>
  );
}
